import { FC, PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

import { ThemeProvider } from '@mui/material';
import { InternationalizationProvider } from '../internationalization/components/InternationalizationProvider';
import { RouterProvider } from '../routes/components/RouterProvider';
import { theme } from '../theme/materialTheme';
import { ToastProvider } from '../ui/ToastProvider';
import { SyncStatusProvider } from './SyncStatusProvider';

export type AppProvidersProps = PropsWithChildren & { queryClient: QueryClient };

export const AppProviders: FC<AppProvidersProps> = ({ children, queryClient }) => {
  return (
    <InternationalizationProvider>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <ThemeProvider theme={theme}>
          <RouterProvider>
            <ToastProvider>
              <SyncStatusProvider>{children}</SyncStatusProvider>
            </ToastProvider>
          </RouterProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </InternationalizationProvider>
  );
};
